export const STORY_UPDATE = "STORY_UPDATE";
export const STORY_ADD_NEW = "STORY_ADD_NEW";
export const STORY_GET_ALL = "STORY_GET_ALL";
export const STORY_DELETE = "STORY_DELETE";